import React from "react";
import styles from "./CircleProgressBar.module.scss";
import classNames from "classnames";
import loaderGif from "../../../assets/img/loader.gif";

class CircleProgressBar extends React.Component {
  render() {
    return (
      <>
        <div className={classNames("container", styles.ContainerProgress)}>
          <div className="row">

            <div className="col-sm-3 col-md-2">
              <img className={styles.progress} src={loaderGif} alt=""/>
            </div>

          </div>
        </div>
      </>
    );
  }

}

export default CircleProgressBar;
